import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Grid, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import t from './translation.js';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		alignItems: 'center'
	},
	radioGroup: {
		padding: theme.spacing(2),
		justifyContent: 'center',
		flexDirection: 'row',
		color: theme.palette.text.secondary
	}
}));

const ExternalViewSwitcher = ({ currentViewName, onChange }) => {
    const { root, radioGroup } = useStyles();

    return (
        <Grid container className={root}>
            <Grid item xs={12}>
                <RadioGroup
                    name="views"
                    aria-label="Views"
                    className={radioGroup}
                    value={currentViewName}
                    onChange={onChange}
                >
                    <FormControlLabel value="Day" control={<Radio color="primary" />} label={t.day} />
                    <FormControlLabel value="Week" control={<Radio color="primary" />} label={t.week} />
                    <FormControlLabel value="Month" control={<Radio color="primary" />} label={t.month} />
                </RadioGroup>
            </Grid>
        </Grid>
    )
}

ExternalViewSwitcher.propTypes = {
    currentViewName: PropTypes.string,
    onChange: PropTypes.func
}

export default ExternalViewSwitcher;
